import { render, staticRenderFns } from "./Tab1.vue?vue&type=template&id=c97d99a0&scoped=true"
import script from "./Tab1.vue?vue&type=script&lang=js"
export * from "./Tab1.vue?vue&type=script&lang=js"
import style0 from "./Tab1.vue?vue&type=style&index=0&id=c97d99a0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97d99a0",
  null
  
)

export default component.exports